import { render, staticRenderFns } from "./generic-menu-link.vue?vue&type=template&id=3a41a997"
import script from "./generic-menu-link.vue?vue&type=script&lang=js"
export * from "./generic-menu-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports